interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Exact "arrow-trend-up" asset from the Create-menu Figma dropdown. */
const FigmaVarianceIcon = ({ width = 16, height = 16, color = '#121826' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.6663 4H10.333C9.78102 4 9.33302 4.448 9.33302 5C9.33302 5.552 9.78102 6 10.333 6H12.5857L8.66635 9.91933L5.92035 7.17333C5.22902 6.482 4.10368 6.482 3.41235 7.17333L0.292349 10.2927C-0.0983177 10.6833 -0.0983177 11.316 0.292349 11.7067C0.683016 12.0973 1.31568 12.0973 1.70635 11.7067L4.66568 8.74733L7.41168 11.4933C7.75768 11.8393 8.21102 12.012 8.66568 12.012C9.12035 12.012 9.57368 11.8387 9.91968 11.4933L13.999 7.414V9.66667C13.999 10.2187 14.447 10.6667 14.999 10.6667C15.551 10.6667 15.999 10.2187 15.999 9.66667V6.33333C15.999 5.04667 14.953 4 13.6663 4Z'
        fill={color}
      />
    </svg>
  );
};

export default FigmaVarianceIcon;
